import { Navigate } from 'react-router';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

/**
 * /customer-rentals ("Website Reservations") is folded into the unified Reservations
 * browser at /booking-requests (UI-1 #494, journey §8). Kept as a redirect so old
 * deep links and bookmarks survive; the FuseNavigation entry was removed from
 * Dorat.Api/appsettings.json.
 */
const customerRentalsRoutes: FuseRouteItemType[] = [
	{
		path: 'customer-rentals',
		element: (
			<Navigate
				to="/booking-requests"
				replace
			/>
		)
	}
];

export default customerRentalsRoutes;
